import { render, staticRenderFns } from "./my_informal_wage_record_modal.vue?vue&type=template&id=576e3450&scoped=true"
import script from "./my_informal_wage_record_modal.vue?vue&type=script&lang=js"
export * from "./my_informal_wage_record_modal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "576e3450",
  null
  
)

export default component.exports